var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ant-upload-preview"},[_c('div',{staticStyle:{"width":"100%"}},[_c('el-upload',{staticClass:"avatar-uploader",attrs:{"show-file-list":false,"action":"","before-upload":_vm.beforeUpload,"http-request":_vm.handleChange}},[(_vm.imageUrl)?_c('img',{staticClass:"avatar",style:({ width: _vm.width + 'px', height: _vm.height + 'px' }),attrs:{"src":_vm.imageUrl}}):_c('span',[(_vm.loading)?_c('i',{staticClass:"el-icon-loading avatar-uploader-icon",style:({
            width: _vm.width + 'px',
            height: _vm.height + 'px',
            lineHeight: _vm.height + 'px',
          })}):_c('span',{staticClass:"empty-box",style:({
            width: _vm.width + 'px',
            height: _vm.height + 'px',
            lineHeight: _vm.height + 'px',
          })},[_c('img',{staticClass:"update_img",attrs:{"src":require("@/assets/icon_update_img.png")}})])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d3074fa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImageCropper/index.vue
// module id = null
// module chunks = 